import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Page, Group, Layout, Button, Grid } from "@/comn/components";
import { useForm, useFetch, useStore, useToast, useTheme, useModal, useResource, useGrid, usePage } from "@/comn/hooks";
import { BASE, URLS, APIS, SF_ROLE_SRCH, SG_SCRH_ROLE_LIST } from "./services/OsciUsrRoleService";
import { Link } from "react-router-dom";

/**
 * Internal role Details
 * !==  내부 사용자 역할 상세 ==!
 *
 */
export const OSCI0104027Q = (props: any) => {
    const { usrIdntfId, ogaUsrRoleList, callback } = props;
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003", "auth_osci0002"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const param = useParams();
    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        roleSrch: useForm({ defaultSchema: SF_ROLE_SRCH, defaultValues: { usrIdntfId } }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        roleList: useGrid({ defaultSchema: SG_SCRH_ROLE_LIST }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getRoleList: useFetch({
            api: (page = grid.roleList.page, size = grid.roleList.size) =>
                APIS.getRoleList(form.roleSrch.getValues(), page, size),
            enabled: true,
            key: [grid.roleList.page, grid.roleList.size],
            onSuccess: () => {},
            onError: () => modal.openModal({ content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const render = {
        checkbox: (row: any) => {
            return row.isRgsrYn !== "Y" && ogaUsrRoleList.findIndex((item: any) => item.roleId === row.roleNm) === -1;
        },
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        onBtnApplyClick: () => {
            if (grid.roleList.getChecked().length === 0) {
                modal.openModal({ content: "msg.osc.00084" }); // No data has been selected.. !== 선택된 데이터가 없습니다. ==!
                return;
            }

            if (callback) callback(grid.roleList.getChecked());
        },
        onBtnSrchClick: () => fetch.getRoleList.fetch(),
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {}, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section gap={2}>
                        <Group.Row>
                            <Group.Control {...form.roleSrch.schema.roleId} />
                            <Group.Control {...form.roleSrch.schema.roleNm} />
                        </Group.Row>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.onBtnSrchClick} />
                        </Layout.Right>
                    </Group.Section>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section gap={2}>
                        <Grid {...grid.roleList.grid} data={fetch.getRoleList.data?.roleList} render={render} />

                        <Layout.Right>
                            <Button role={"apply"} onClick={handler.onBtnApplyClick} />
                        </Layout.Right>
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
